(function () {

  const interval = setInterval(() => {

    // ============================================================
    // 1. ADD FIELD ERROR CLASSES
    // ============================================================
    document.querySelectorAll(".onst-field").forEach(field => {

      if (field.dataset.errorObserver) return;

      const warning = field.querySelector(".onst-warning");

      if (!warning) return;

      const updateErrorState = () => {

        field.classList.toggle(
          "field-error",
          warning.classList.contains("onstactive")
        );

      };

      // Initial state
      updateErrorState();

      // Watch warning class changes
      new MutationObserver(updateErrorState).observe(warning, {
        attributes: true,
        attributeFilter: ["class"]
      });

      field.dataset.errorObserver = "true";

    });


    // ============================================================
    // 2. CLEAR ERROR WHEN FIELD HAS VALUE
    // ============================================================
    document
      .querySelectorAll(
        ".onst-field input, .onst-field select, .onst-field textarea"
      )
      .forEach(input => {

        if (input.dataset.errorHandler) return;

        input.dataset.errorHandler = "true";

        input.addEventListener("input", function () {

          const field = this.closest(".onst-field");
          const warning = field?.querySelector(".onst-warning");

          if (!field || !warning) return;

          if (this.value.trim() !== "") {

            warning.classList.remove("onstactive");
            field.classList.remove("field-error");

          }

        });


        input.addEventListener("change", function () {

          this.dispatchEvent(new Event("input"));

        });

      });


    // ============================================================
    // 3. COUNTRY DROPDOWN
    //
    // Remove all countries except:
    // - Empty/default "Select Country"
    // - United States
    //
    // IMPORTANT:
    // We DO NOT automatically select United States.
    // ============================================================
    let countryDone = false;

    const countrySelect =
      document.querySelector(".onstcountryselector");


    if (
      countrySelect &&
      !countrySelect.dataset.filtered
    ) {

      [...countrySelect.options].forEach(option => {

        if (!["", "US"].includes(option.value)) {

          option.remove();

        }

      });

      countrySelect.dataset.filtered = "true";

    }


    if (
      countrySelect?.dataset.filtered === "true"
    ) {

      countryDone = true;

    }


    // ============================================================
    // 4. PHONE NUMBER VALIDATION
    // ============================================================
    let phoneDone = false;

    const phoneInput =
      document.querySelector("#wRegisterForm-tel-5");


    if (
      phoneInput &&
      !phoneInput.dataset.validationAdded
    ) {

      phoneInput.dataset.validationAdded = "true";


      const form =
        phoneInput.closest("form");


      const field =
        phoneInput.closest(".onst-field");


      const warning =
        field
          ? field.querySelector(".onst-warning")
          : null;


      // ==========================================================
      // SHOW PHONE ERROR
      // ==========================================================
      function showPhoneError(message) {

        if (!warning) return;

        warning.textContent = message;

        warning.classList.add("onstactive");

        if (field) {

          field.classList.add("field-error");

        }

      }


      // ==========================================================
      // HIDE PHONE ERROR
      // ==========================================================
      function hidePhoneError() {

        if (!warning) return;

        warning.textContent = "";

        warning.classList.remove("onstactive");

        if (field) {

          field.classList.remove("field-error");

        }

      }


      // ==========================================================
      // VALIDATE PHONE NUMBER
      //
      // We only READ the value.
      // We do NOT modify the input value.
      // ==========================================================
      function validatePhone() {

        const value =
          phoneInput.value.trim();


        // Remove everything except numbers
        let digits =
          value.replace(/\D/g, "");


        /* +1 is the US country code.  */
        if (
          digits.startsWith("1") &&
          digits.length >= 1
        ) {

          digits =
            digits.substring(1);

        }


        // --------------------------------------------------------
        // No number entered
        // --------------------------------------------------------
        if (digits.length === 0) {

          showPhoneError(
            "This field is required."
          );

          return false;

        }


        // --------------------------------------------------------
        // Exactly 10 digits required after +1
        // --------------------------------------------------------
        if (digits.length !== 10) {

          showPhoneError(
            "Please enter a valid 10-digit US phone number."
          );

          return false;

        }


        // --------------------------------------------------------
        // Valid
        // --------------------------------------------------------
        hidePhoneError();

        return true;

      }


      // ==========================================================
      // PHONE INPUT VALIDATION
      //
      // IMPORTANT:
      //
      // We DO NOT change this.value.
      //
      // This prevents:
      // +1 becoming +11
      // +11 becoming +111
      //
      // and also prevents the existing value from being cleared.
      // ==========================================================
    // ==========================================================
// PHONE INPUT VALIDATION
//
// +1 + maximum 10 digits
// Extra digits are not allowed.
// ==========================================================
let lastValidPhoneValue = phoneInput.value;

phoneInput.addEventListener(
  "input",
  function () {

    const cleanedValue = this.value.replace(/[^\d+]/g, "");

      if (this.value !== cleanedValue) {
        this.value = cleanedValue;
      }

    const value = this.value;


    // Count only numeric digits
    let digits = value.replace(/\D/g, "");

    // Remove only the +1 country code for validation
    if (
      digits.startsWith("1") &&
      digits.length >= 1
    ) {
      digits = digits.substring(1);
    }

    // --------------------------------------------------------
    // Do not allow more than 10 digits after +1
    // --------------------------------------------------------
    if (digits.length > 10) {

      this.value = lastValidPhoneValue;

      return;

    }

    // Save current value as valid value
    lastValidPhoneValue = this.value;

    // Normal validation
    validatePhone();

  }
);


      // ==========================================================
      // PHONE BLUR VALIDATION
      //
      // When user clicks outside the field,
      // only validation runs.
      //
      // Existing phone value remains untouched.
      // ==========================================================
      phoneInput.addEventListener(
        "blur",
        function () {

          validatePhone();

        }
      );


      // ==========================================================
      // FORM SUBMIT VALIDATION
      // ==========================================================
      if (
        form &&
        form.dataset.phoneSubmitValidation !== "true"
      ) {

        form.dataset.phoneSubmitValidation = "true";


        form.addEventListener(
          "submit",
          function (event) {

            if (!validatePhone()) {

              event.preventDefault();

              phoneInput.focus();

            }

          }
        );

      }


      phoneDone = true;


    } else if (
      phoneInput?.dataset.validationAdded === "true"
    ) {

      phoneDone = true;

    }


    // ============================================================
    // 5. MOVE DESCRIPTION BOX
    // ============================================================
    const descriptionBox =
      document.querySelector(".descriptionbox");


    if (
      descriptionBox &&
      !descriptionBox.dataset.moved
    ) {

      // Hide parent .onst-field
      const parentField =
        descriptionBox.closest(".onst-field");


      if (parentField) {

        parentField.style.display = "none";

      }


      // Find checkbox label
      const checkboxLabel =
        document
          .querySelector(
            "#wRegisterForm-checkbox-9-inner-0"
          )
          ?.closest("label");


      if (checkboxLabel) {

        checkboxLabel.appendChild(
          descriptionBox
        );

        descriptionBox.dataset.moved =
          "true";

      }

    }


    // ============================================================
    // 6. STATIC US FLAG + US TEXT
    //
    // The original country-code dropdown is hidden.
    //
    // A non-clickable static:
    //
    // [ US FLAG ] US
    //
    // is displayed instead.
    //
    // This does NOT modify the phone input value.
    // ============================================================
    const phoneWrapper =
      document.querySelector(
        ".surecust-phone-input-wrapper"
      );


    if (
      phoneWrapper &&
      !phoneWrapper.dataset.staticCountryAdded
    ) {

      const phoneSelect =
        phoneWrapper.querySelector("select");


      if (phoneSelect) {

        // --------------------------------------------------------
        // Create static country container
        // --------------------------------------------------------
        const staticCountry =
          document.createElement("div");


        staticCountry.className =
          "static-phone-country";


        staticCountry.style.cssText = `
          width: 105px;
          height: 48px;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 7px;
          background: #ffffff;
          border: 1px solid #a3a3a3;
          border-radius: 4px;
          padding: 0 8px;
          box-sizing: border-box;
          font-size: 14px;
          flex-shrink: 0;
          cursor: default;
        `;


        // --------------------------------------------------------
        // US FLAG IMAGE
        // --------------------------------------------------------
        const flagImage =
          document.createElement("img");


        flagImage.src =
          "https://cdn.shopify.com/s/files/1/0675/9651/7507/files/Screenshot_2026-08-10_at_11.07.01_PM.png";


        flagImage.alt = "US";


        flagImage.style.cssText = `
          width: 28px;
          height: 18px;
          display: block;
          object-fit: cover;
        `;


        // --------------------------------------------------------
        // US TEXT
        // --------------------------------------------------------
        const countryText =
          document.createElement("span");


        countryText.textContent = "US";


        countryText.style.cssText = `
          font-size: 18px;
        `;


        // --------------------------------------------------------
        // Add flag + US text
        // --------------------------------------------------------
        staticCountry.appendChild(
          flagImage
        );


        staticCountry.appendChild(
          countryText
        );


        // --------------------------------------------------------
        // Insert static country display
        // --------------------------------------------------------
        phoneWrapper.insertBefore(
          staticCountry,
          phoneSelect
        );


        // --------------------------------------------------------
        // Hide original phone country dropdown
        // --------------------------------------------------------
        phoneSelect.style.display =
          "none";


        phoneWrapper.dataset.staticCountryAdded =
          "true";

      }

    }


    // ============================================================
    // 7. STOP POLLING
    // ============================================================
    if (
      countryDone &&
      phoneDone
    ) {

      clearInterval(interval);

    }


  }, 300);


  // ============================================================
  // 8. SAFETY TIMEOUT
  // ============================================================
  setTimeout(() => {

    clearInterval(interval);

  }, 30000);


})();